import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { toast } from 'react-hot-toast';
import { getOrderById, markOrderAsConfirmed } from 'api/orders';
import { formatDateForOrder } from 'utils/dates';

import Content from './Content';

import { getArrayOfErrors } from 'utils/errors';
import { useDispatch, useSelector } from 'react-redux';
import { setErrorToken } from '../../../../redux/authSlice/authSlice';
import { HomeLayouts } from '../../../../components/layouts/HomeLayout';
import { confirmationOrder, updatesupplierStatus, getIntegrationCredentials, addToContifico } from '../../../../api/orders';

const RecieveOrder = () => {
  const { user, token, subscription } = useSelector((state) => state.auth)
  const { id, restaurant } = useParams();
  const [note, setNote] = useState('');
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const dispatch = useDispatch()
 const [showModal, setShowModal] = useState(false);

  const signature = ()=>{
    setShowModal(true)
  

  }

const updateStatusSup = async (status)=>{


  const transformedProducts = order.products.map(product => ({

     id: product.id,
    quantity: order.status === 'aceptada' && product.confirmedQuantity !== null ? product.confirmedQuantity : product.requestedQuantity|| 0,
  }));

    const requestOrder = {
      status,
      products: transformedProducts,
    };


     try {
     
        const resp = await updatesupplierStatus(order.code, requestOrder, token)

       
         toast.success( status === 'Listo Para Despachar' ? 'Orden en estado Lista para despachar': 'Orden en estado En Ruta');
        navigate(`/ordenes`);
    } catch (error) {
      if (error.response) {
        const errors = getArrayOfErrors(error.response.data);

        if (error.response.data === 'Su token ha caducado por favor vuelve a iniciar sesión') {

          dispatch(setErrorToken(true))

        } else {
          for (let i = 0; i < errors.length; i++) {
            toast.error(errors[i]);
          }
        }
      } else {
        toast.error('Error interno. Inténtelo más tarde');
      }
    }



}


 const receiveSignature = async (date, signature, signerid, status) => {

    const requestOrderSupp = {
      status,
      products: [],
    };

        for (let i = 0; i < order.products.length; i++) {
      let key = 'confirmedQuantity';
      requestOrderSupp.products.push({
        id: order.products[i].id,       
        quantity: order.products[i][key],
      });
    }

    const currentDate = new Date();
    const formattedDate = formatDateForOrder(currentDate);
    const requestOrder = {
      products: [],
      note:'',
      noteSupplier:note,
      scheduleDate: formattedDate,
    };

    for (let i = 0; i < order.products.length; i++) {
      let key = 'confirmedQuantity';
      requestOrder.products.push({
        id: order.products[i].id,       
        deliveredQuantity: order.products[i][key],
      });
    }


    console.log(requestOrder,  requestOrderSupp )

   try {
      const responseOrder = await confirmationOrder( order.restaurant.id,  order.id, order.restaurantUser.id, token, signature, '', signerid, requestOrder);
      const resp = await updatesupplierStatus(order.code, requestOrderSupp, token)
      
      const processIntegration = async () => {
        try {
          const integrationCredentials = await getIntegrationCredentials(order.supplier.id, token);
          const hasContifico = integrationCredentials?.length > 0 && integrationCredentials[0].integrationName === 'Contifico';
          
          if (hasContifico) {
            // hacer el proceso de contifico por detras para que la db se actualice bien
            setTimeout(async () => {
              try {
                await addToContifico(order.code, token);
                console.log('Factura Contifico generada exitosamente');
                toast.success('Factura electrónica creada exitosamente');
              } catch (contificoError) {
                console.error('Error generando factura Contifico:', contificoError);
                toast.error('No fue posible crear la facturación electrónica');
              }
            }, 2500);

            return 'Orden entregada. Creando factura...';
          } else {
            return 'Orden entregada';
          }
        } catch (integrationError) {
          console.error('Error verificando integración:', integrationError);
          return 'Orden entregada';
        }
      };

      // Ejecutar integracion y mostrar mensaje retornado en el toast
      const message = await processIntegration();
      toast.success(message);

      navigate(`/ordenes`);
    } catch (error) {
      if (error.response) {
        const errors = getArrayOfErrors(error.response.data);

        if (
          error.response.data === 'Su token ha caducado por favor vuelve a iniciar sesión'
        ) {
          dispatch(setErrorToken(true));
        } else {
          for (let i = 0; i < errors.length; i++) {
            toast.error(errors[i]);
          }
        }
      } else {
        toast.error('Error interno. Inténtelo más tarde');
      }
    }
  };

  const receive = async (date, signature, signerid) => {
    const formattedDate = formatDateForOrder(date);
    const requestOrder = {
      products: [],
      note: '',
      noteSupplier: note,
      scheduleDate: formattedDate,
    };

    for (let i = 0; i < order.products.length; i++) {
      let key = 'requestedQuantity';
      requestOrder.products.push({
        id: order.products[i].id,
        confirmedQuantity: order.products[i][key],
      });
    }
    try {
      const responseOrder = await markOrderAsConfirmed(
        requestOrder,
        restaurant,
        order.id,
        token,
        user?.id,
        signature,
        signerid,
      );

      navigate(`/ordenes/confirmacion/${responseOrder.code}/${restaurant}`);
    } catch (error) {
      if (error.response) {
        const errors = getArrayOfErrors(error.response.data);

        if (
          error.response.data === 'Su token ha caducado por favor vuelve a iniciar sesión'
        ) {
          dispatch(setErrorToken(true));
        } else {
          for (let i = 0; i < errors.length; i++) {
            toast.error(errors[i]);
          }
        }
      } else {
        toast.error('Error interno. Inténtelo más tarde');
      }
    }
  };

  useEffect(async () => {
    try {
      const order = await getOrderById(user?.id, restaurant, id, token);
      setOrder(order);
    } catch (error) {
      if (error.response) {
        const errors = getArrayOfErrors(error.response.data);

        if (
          error.response.data === 'Su token ha caducado por favor vuelve a iniciar sesión'
        ) {
          dispatch(setErrorToken(true));
        } else {
          for (let i = 0; i < errors.length; i++) {
            toast.error(errors[i]);
          }
        }
      } else {
        toast.error('Error interno. Inténtelo más tarde');
      }
    }
  }, []);

  if (!order) return <HomeLayouts></HomeLayouts>;
  if (!order.products.length) navigate(-1);

  return (
    <Content
      note={note}
      updateStatusSup={updateStatusSup}
      setNote={setNote}
      id={id}
      order={order}
      setOrder={setOrder}
      receive={receive}
      restaurant={restaurant}
      signature={signature}
      setShowModal={setShowModal}
      showModal={showModal}
      receiveSignature={receiveSignature}
    />
  );
};

export default RecieveOrder;
